<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
         <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Daily report</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Update</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_date"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Date"
                      v-model="dateFormatted"
                      prepend-icon="event"
                      readonly
                      :rules="itemRules"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.date" no-title scrollable
                  @input="dateFormatted = formatDate($event)"
                  @change="menu_date=false"
                  >
                  </v-date-picker>
                </v-menu>

              </v-flex>

              <v-flex xs12 sm3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_time"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Time"
                      v-model="form.time"
                      prepend-icon="access_time"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-time-picker v-model="form.time"
                  color="primary"
                  format="24hr"
                  autosave
                  @change="menu_time=false"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
             <v-flex xs12 sm6>

              <v-select
                label="User"
                v-model="form.user"
                :items="users"
                item-text="firstname"
                item-value="id"
                hide-details
              ></v-select>

              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Report"
                  v-model="form.report"
                  prepend-icon="chat"
                  :rules="itemRules"
                  required
                  auto-grow
                  outlined
                  rows="5"
                  row-height="25"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import moment from 'moment';
  import FormMixin from '@/mixins/daily-form';
  export default {
    mixins: [FormMixin],
    props: ['dialog', 'report', 'form'],
    data () {
      return {
        valid: false,
        menu_time: false,
        menu_date: false,
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.$emit('update', this.form);
        } else {
          console.log('error: daily form not valid');
        }
      },
      prefill (d) {
        for (var key in d) {
          this.form[key] = d[key]; // copies each property to the form object
        }
        this.dateFormatted = this.form.date;
        this.form.date = this.unformatDate(d.date);

        console.log(this.dateFormatted);
        this.getUsers();
      },
      init (v) {
        if (v) {
          this.prefill(this.report);
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>

